import Header from '@/components/Header/Header';
import { createFileRoute } from '@tanstack/react-router';
import { FormattedMessage, useIntl } from 'react-intl';
import { useGetTenant } from '@/api/trafikportalen';
import MarkdownContent from '@/MarkdownContent.tsx';
import { Loading } from '@/components/Loading.tsx';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute('/$tenantId/_layout/support/')({
  component: Support,
});

function Support() {
  const { data: tenant, isLoading } = useGetTenant();
  const { formatMessage } = useIntl();

  if (isLoading || !tenant) {
    return <Loading />;
  }

  return (
    <div className="overflow-y-auto">
      <DocumentHead
        titleKey="page.support.title"
        descriptionKey="page.support.description"
      />
      <Header title={<FormattedMessage defaultMessage="Support" />} />
      <section className="mb-12 flex justify-center p-4 md:flex-row md:p-8 lg:mb-0">
        <MarkdownContent
          markdownText={
            tenant.support ||
            formatMessage({
              defaultMessage: 'Det finns ingen support information ännu.',
            })
          }
        />
      </section>
    </div>
  );
}
